<div id="translation-select">
  <table>
    <tr>
      <td width="100%"></td>
      <td>
        <div *ngIf="loggedIn">
          <a (click)="logout()">
            <iron-icon icon="lock"></iron-icon>
          </a>
        </div>
      </td>
      <td>
        <div *ngIf="hasHelpLink">
          <a href="{{helpLink}}" target="_blank">
            <iron-icon icon="help"></iron-icon>
          </a>
        </div>
      </td>
      <td>
        <iron-icon icon="language"></iron-icon>
      </td>
      <td>
        <t-select basePath="./assets/" label="Language:" pathToTranslationDefinitions="./assets/translations.json"></t-select>
      </td>
    </tr>
  </table>
</div>
<div class="tangerine-app-content mat-typography">
  <router-outlet></router-outlet>
</div>
